/* eslint-disable i18next/no-literal-string */
import React, { useEffect, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import Box from '@mui/material/Box';
import DocViewerFit from 'app/components/Common/DocViewer/DocViewer';
import { CircularProgress, Grid, Paper, Alert } from '@mui/material';
import GetAppIcon from '@mui/icons-material/GetApp';
import DeleteIcon from '@mui/icons-material/Delete';
import AttachementsCredentialDetails from './AttachementsCredentialDetails';
import { getCredentialName } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/CredentialsTab/TableData/tableHelpers';
import {
  downloadFile,
  getFileNameFormat,
  isNullWithDefaultVal,
  isNullWithEmptyVal,
  isPrevSupported,
  isFileTypeHtml,
  getDocumentIdFromUrl,
} from 'app/components/Common/DocViewer/Helpers/DocHelpers';
import { useTranslation } from 'react-i18next';
import Moment from 'moment';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import LanguageIcon from '@mui/icons-material/Language';
import { onDeleteAttachment } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/CredentialsTab/CredentialsHelpers';
import { useDispatch, useSelector } from 'react-redux';
import { IAttachments } from 'app/models/Credentialing/Credentials';
import { candidateDetailActions } from 'app/components/Candidate/CandidateProfile/Profile/CandidateDetails.redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import _ from 'lodash';
import { selectUser } from 'oidc/user.selectors';
import { selectViewSkillsChecklistPassport } from '@AMIEWEB/Candidate/CandidateProfile/Profile/CandidateDetails.selector';
import { isCredentialing, userRoles } from 'oidc/userRoles';
import { ViewSkillChecklist } from './ViewSkillCheckList/ViewSkillChecklist';
import { GenericDialog } from '@AMIEWEB/Alerts/GenericDialog';
import { globalActions } from 'app/ApplicationRoot/Global.redux';
import { Authorized } from 'oidc/userHelper';
import { manuallyDecrementPromiseCounter, manuallyIncrementPromiseCounter, trackPromise, usePromiseTracker } from 'react-promise-tracker';
import { CustomBackdrop } from '@AMIEWEB/Common/Backdrop/CustomBackdrop';
import { getDocument } from 'app/services/CredentialingServices/CredentialingServices';
import { SharedService } from 'app/services/SharedServices/shared-service';
import { httpSuccess } from 'app/services/serviceHelpers';
import { base64DocumentToURL } from 'app/helpers/fileHelper';
import { trackException } from 'app-insights/appInsightsTracking';
import { ExceptionType } from 'app/enums/Common';

const useStyles: any = makeStyles()(theme => ({
  icon: {
    color: '#B9BBBC',
    cursor: 'pointer',
    '&:hover': {
      color: '#006FB9',
    },
  },
  disableIcon: {
    color: theme.palette.framework.system.lightGray,
    cursor: 'not-allowed',
    '&:hover': {
      color: theme.palette.framework.system.lightGray,
    },
  },
  link: {
    color: '#006FB9',
    cursor: 'pointer',
  },
  title: {
    textAlign: 'left',
    font: 'normal normal normal 16px/21px Roboto',
    letterSpacing: '0px',
    color: '#7d7b7b',
    opacity: 1,
    fontWeight: 500,
  },
  content: {
    marginTop: '2%',
  },
  sections: {
    paddingLeft: '15px',
    paddingRight: '15px',
  },
  alert: {
    '& .MuiAlert-icon': {
      fontSize: 24,
      color: '#694D28',
    },
    height: '52px',
    fontSize: 'inherit',
  },
  seperator: {
    margin: '0 8px',
  },
  paperOverride: {
    padding: '22px 25px 25px 22px !important',
  },
  hide: {
    display: 'none',
  },
  doc: {
    padding: theme.spacing(2),
    textAlign: 'center',
  },
  supportDoc: {
    color: '#797676',
    fontSize: 400,
  },
  MuiCircularProgressRoot: {
    left: '50%',
    position: 'absolute',
    top: '50vh',
  },
}));

export const AttachmentsTabContent = props => {
  const { classes } = useStyles();
  const attachment: any = props.attachment;
  const attachmentList: any = props.attachmentList;
  const credential: any = props.credentials;
  const lookupsProp: any = props.credentialLookUps;
  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);
  const [inlineAttachments, setInlineAttachments] = useState<IAttachments[]>([]);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const history = useNavigate();
  const location = useLocation();
  const user = useSelector(selectUser);
  const viewSkillsChecklistPassport = useSelector(selectViewSkillsChecklistPassport);
  const [attachmentFileData, setAttachmentFileData] = useState(null);
  const { promiseInProgress } = usePromiseTracker({ area: 'single-attachment', delay: 0 });
  const { promiseInProgress: downloadInProgress } = usePromiseTracker({ area: 'skills-checklist-download', delay: 0 });

  const { /*reqId, reqTypeId,*/ travelerId, brandId } = useParams<any>();

  useEffect(() => {
    const uri: string = attachment?.document?.uri || '';

    if (uri.length > 0 && uri.includes('/')) {
      const fetchDocument = async () => {
        const data = await getDocument(props.candidateId, getDocumentIdFromUrl(uri));
        const documentData = {
          uri,
          fileType: data?.fileType,
          fileData: data?.fileData,
        };
        setAttachmentFileData(documentData);
      };

      trackPromise(fetchDocument(), 'single-attachment');
    }
  }, [attachment?.travelerRequirementImageID]);

  const onDeleteSelected = (e, item) => {
    setInlineAttachments([item]);
    setOpenDeleteConfirmation(true);
  };

  const refreshPage = (attachmentIds?) => {
    setTimeout(function () {
      if (attachmentIds && attachmentIds.length) {
        history(`${location.pathname.split('?')[0]}${`?at=${attachmentIds}`}`, {
          replace: true,
          state: { navigateBack: true },
        });
      } else {
        history(`/candidate/${travelerId}/${brandId}?tab=1`);
      }
    }, 1500);
  };

  const DeleteAttachmentItem = async (item: IAttachments) => {
    let processSucess = true;
    await onDeleteAttachment(props.candidateId, props.requirementID, item, attachmentList, dispatch)
      .then(res => {
        if (res) {
          //
        }
      })
      .catch(err => {
        processSucess = false;
      })
      .finally(() => {});
    return processSucess;
  };

  const handleDeleteConfirmClose = async (modalState: boolean, clearValues: boolean) => {
    setOpenDeleteConfirmation(modalState);
    if (clearValues) {
      if (inlineAttachments.length > 0 && inlineAttachments[0]) {
        const item = inlineAttachments[0];
        let processSucess = true;
        const deletedAttchements: IAttachments[] = [];
        if (item.travelerRequirementImageID) {
          setIsDeleting(true);
          dispatch(
            globalActions.setSnackBar({
              message: t('search.grid.download.deleteMessage'),
              severity: 'error',
              iconColor: 'blue',
              onSnackClose: () => setIsDeleting(false),
            }),
          );
          await DeleteAttachmentItem(item).then(result => {
            if (!result) {
              processSucess = false;
            } else {
              deletedAttchements.push(item);
            }
          });
          if (processSucess) {
            globalActions.setSnackBar({
              message: t('search.grid.delete.snackbarSuccess'),
              severity: 'success',
            });
            setIsDeleting(false);
            //update redux
            const remaingAttchements: IAttachments[] = [];
            attachmentList?.map(item => {
              const attachmentItems = deletedAttchements?.filter(t => t.sortOrder === item.sortOrder);
              if (!attachmentItems || attachmentItems.length <= 0) {
                remaingAttchements.push(item);
              }
            });
            dispatch(
              candidateDetailActions.setAttachments(
                remaingAttchements.sort(function (a, b) {
                  return a.sortOrder > b.sortOrder ? 1 : b.sortOrder > a.sortOrder ? -1 : 0;
                }),
              ),
            );
            dispatch(candidateDetailActions.setSelPreviewAttachments(remaingAttchements));
            dispatch(candidateDetailActions.setHistoryAttachments(remaingAttchements));

            const sortedAttachments = _.orderBy(
              remaingAttchements?.map((item, idx) => {
                return { ...item, sortOrder: idx };
              }),
              (o: any) => {
                return o != null ? o.lastUpdated : o;
              },
              ['desc'],
            );
            //reload view
            const filterAttachmentIds = sortedAttachments?.map(x => x.sortOrder);
            refreshPage(filterAttachmentIds);
          } else {
            dispatch(
              globalActions.setSnackBar({
                message: t('search.grid.delete.snackbarError'),
                severity: 'error',
              }),
            );
            setIsDeleting(false);
          }
        }
      }
    }
  };

  const UnsupportedFile = (doctype: { doctype: string }) => {
    const { classes } = useStyles();

    return (
      <Grid container spacing={3}>
        <Grid item xs={12} className={classes.doc}>
          {isFileTypeHtml(doctype.doctype) ? (
            <LanguageIcon className={classes.supportDoc} />
          ) : (
            <DescriptionOutlinedIcon className={classes.supportDoc} />
          )}
        </Grid>
      </Grid>
    );
  };

  /**
   * Method to render document viewer / skill checklist pdf generation
   */
  const renderDocumentForAttachments = () => {
    if (attachment?.isSkillChecklist) {
      return <ViewSkillChecklist credentialDateCompleted={credential?.credential?.dateCompleted} />;
    } else if (isPrevSupported(attachmentFileData?.fileType)) {
      return <DocViewerFit docs={[attachmentFileData]} preview={false} />;
    } else {
      return <UnsupportedFile doctype={attachmentFileData?.fileType} />;
    }
  };

  const handleDownload = async event => {
    event.stopPropagation();
    if (attachment?.isSkillChecklist) {
      const skillsChecklistId = viewSkillsChecklistPassport?.id ? parseInt(String(viewSkillsChecklistPassport.id), 10) : null;
      if (!skillsChecklistId) return;
      const trackerArea = 'skills-checklist-download';
      try {
        manuallyIncrementPromiseCounter(trackerArea);
        const sharedService = SharedService.getInstance();
        const response = await sharedService.getSkillsChecklistDocument(skillsChecklistId);
        if (response && httpSuccess(response?.status)) {
          const base64Data = response.data?.data ?? response.data?.filebytes;
          if (base64Data) {
            base64DocumentToURL(base64Data, {
              fileType: 'application/pdf',
              download: true,
              fileName: response.data?.fileName ?? getFileNameFormat(
                credential?.credential?.credentialName,
                props.attachmentsNum,
                credential?.credential?.lastUpdate ?? attachment?.lastUpdated,
              ),
            });
            dispatch(
              globalActions.setSnackBar({
                message: t('search.grid.download.successMessage'),
                severity: 'success',
              }),
            );
          } else {
            dispatch(
              globalActions.setSnackBar({
                message: t('search.grid.download.failedMessage', { defaultValue: 'Download failed' }),
                severity: 'error',
              }),
            );
          }
        } else {
          dispatch(
            globalActions.setSnackBar({
              message: t('search.grid.download.failedMessage', { defaultValue: 'Download failed' }),
              severity: 'error',
            }),
          );
        }
      } catch (error) {
        trackException({
          exception: error,
          properties: {
            name: ExceptionType.CommonUIError,
            functionName: 'AttachmentsTabContent_handleDownload_skillsChecklist',
            area: 'src/app/components/Credentialing/CredentialingAttachmentsViewer/AttachmentsViewer/AttachmentsTabContent.tsx',
          },
        });
        dispatch(
          globalActions.setSnackBar({
            message: t('search.grid.download.failedMessage', { defaultValue: 'Download failed' }),
            severity: 'error',
          }),
        );
      } finally {
        manuallyDecrementPromiseCounter(trackerArea);
      }
    } else {
      dispatch(
        globalActions.setSnackBar({
          message: t('search.grid.download.successMessage'),
          severity: 'success',
        }),
      );
      downloadFile(
        attachment?.document?.uri,
        attachmentFileData?.fileData,
        getFileNameFormat(credential?.credential?.requirementType, props.attachmentsNum, attachment?.lastUpdated),
        attachmentFileData?.fileType,
      );
    }
  };

  const displayDateAdded = () => {
    if (attachment?.isSkillChecklist) {
      return credential.credential.lastUpdate != null
        ? Moment(credential.credential.lastUpdate).format('MM/DD/YYYY h:mm:ss a')
        : 'N/A';
    } else {
      return attachment?.lastUpdated != null ? Moment(attachment?.lastUpdated).format('MM/DD/YYYY') : 'N/A';
    }
  };

  return (
    <React.Fragment>
      {isDeleting && <CircularProgress className={classes.MuiCircularProgressRoot} />}
      <Grid container spacing={2} className={classes.sections}>
        <Grid item xs={9}>
          {attachment !== null ? (
            <Paper className={`paper ${classes.paperOverride}`} elevation={0}>
              <Grid container className={classes.title}>
                <Grid item xs={6}>
                  {getCredentialName(credential?.credential?.requirementType, credential?.credential?.credentialName)}
                </Grid>
                <Grid item xs={6}>
                  <Grid container spacing={1} justifyContent="flex-end">
                    <Grid item>
                      <Box>
                        <Box component="span" className={classes.seperator}>
                          {'Status:'}
                        </Box>
                        <Box component="span" className={classes.link}>
                          {isNullWithDefaultVal(attachment?.status)}
                        </Box>
                        <Box component="span" className={classes.seperator}>
                          {'|'}
                        </Box>
                        <Box component="span" className={classes.seperator}>
                          {'Added By:'}
                        </Box>
                        <Box component="span" className={classes.link}>
                          {attachment?.isSkillChecklist
                            ? `${credential.credential.lastUpdatedByName.first} ${credential.credential.lastUpdatedByName.last}`
                            : isNullWithDefaultVal(attachment?.lastUpdatedBy)}
                        </Box>
                        <Box component="span" className={classes.seperator}>
                          {'|'}
                        </Box>
                        <Box component="span" className={classes.seperator}>
                          {'Date Added:'}
                        </Box>
                        <Box component="span" className={classes.link}>
                          {displayDateAdded()}
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item spacing={1} onClick={event => !attachment?.isSkillChecklist ? handleDownload(event) : {}} data-testid="attachment-download">
                      <GetAppIcon className={!attachment?.isSkillChecklist ? classes.icon : classes.disableIcon} />
                    </Grid>
                    {!isFileTypeHtml(attachment?.document?.fileType) ? (
                      <Grid
                        item
                        onClick={e =>
                          !attachment?.isSkillChecklist &&
                          (isCredentialing(user?.userInfo?.roles || []) ||
                            Authorized([userRoles.clinical_ClientContractSpecialist], user?.userInfo)) &&
                          onDeleteSelected(e, attachment)
                        }
                        data-testid="attachment-delete"
                      >
                        <DeleteIcon
                          className={
                            (isCredentialing(user?.userInfo?.roles || []) ||
                              Authorized([userRoles.clinical_ClientContractSpecialist], user?.userInfo)) &&
                            !attachment?.isSkillChecklist
                              ? classes.icon
                              : classes.disableIcon
                          }
                        />
                      </Grid>
                    ) : (
                      ''
                    )}
                  </Grid>
                </Grid>
              </Grid>
              <Grid container spacing={3} className={classes.content}>
                <Grid item xs={12} className={attachment?.status != 'Incomplete' ? classes.hide : ''}>
                  <Alert severity="warning" className={classes.alert}>
                    <div>{attachment?.status}</div>
                  </Alert>
                </Grid>
                <Grid item xs={12}>
                  <Box>
                    <Box component="span">{isNullWithEmptyVal(attachment?.comments)}</Box>
                  </Box>
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Box>
                    <Grid container item direction="column" justifyContent="space-evenly">
                      {(promiseInProgress || downloadInProgress) ? (
                        <CustomBackdrop open={promiseInProgress || downloadInProgress} />
                      ) : (
                        renderDocumentForAttachments()
                      )}
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          ) : (
            <Paper className={'paper'} elevation={0}>
              {'Not Attachments Found'}
            </Paper>
          )}
        </Grid>
        <Grid item xs={3}>
          <AttachementsCredentialDetails credentials={credential} lookups={lookupsProp} />
        </Grid>
      </Grid>
      <GenericDialog
        open={openDeleteConfirmation}
        disableEscapeKeyDown
        maxWidth="sm"
        fullWidth
        dialogTitleProps={{
          text: t('search.grid.delete.dialogSureTitle'),
        }}
        dialogActions={[
          {
            text: t('search.grid.delete.dialogCancelButton'),
            variant: 'text',
            color: 'tertiary',
            onClick: () => handleDeleteConfirmClose(false, false),
          },
          {
            text: t('Ok'),
            variant: 'contained',
            color: 'primary',
            onClick: () => handleDeleteConfirmClose(false, true),
          },
        ]}
      >
        <span>{t('search.grid.delete.dialogDeleteContent')}</span>
      </GenericDialog>
    </React.Fragment>
  );
};

export default AttachmentsTabContent;
